export default function AmountIcon() {
  return (
    <svg
      width="20"
      height="12"
      viewBox="0 0 20 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.75 11L18.75 6.625M6.25 11L1.25 6.625M13.75 1L18.75 5.375M6.25 1L1.25 5.375M1.875 1H18.125C18.4702 1 18.75 1.27982 18.75 1.625V10.375C18.75 10.7202 18.4702 11 18.125 11H1.875C1.52982 11 1.25 10.7202 1.25 10.375V1.625C1.25 1.27982 1.52982 1 1.875 1ZM12.5 6C12.5 7.38071 11.3807 8.5 10 8.5C8.61929 8.5 7.5 7.38071 7.5 6C7.5 4.61929 8.61929 3.5 10 3.5C11.3807 3.5 12.5 4.61929 12.5 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
